import { gql } from '@apollo/client';

export const VALIDATE_MEETING_PACKAGE_VENUE_QUERY = gql`
  query ValidateMeetingPackageVenue($spaceId: Int!, $venueId: String!) {
    validateMeetingPackageVenue(spaceId: $spaceId, venueId: $venueId) {
      name
    }
  }
`;

export const SYNC_MEETING_PACKAGE_VENUE_MUTATION = gql`
  mutation SyncMeetingPackageVenue($hotelId: Int!, $venueId: String!) {
    syncMeetingPackageVenue(hotelId: $hotelId, venueId: $venueId)
  }
`;

export const DISABLE_MEETING_PACKAGE_VENUE_MUTATION = gql`
  mutation DisableMeetingPackageVenue($hotelId: Int!) {
    disableMeetingPackageVenue(hotelId: $hotelId)
  }
`;
